import getSlugFromProductUrl from 'commons/getSlugFromProductUrl';
import getPath from 'commons/getPath';

const getQuickViewStateFromProduct = product => {
  if (!product?.url) {
    return null;
  }

  try {
    const slug = getSlugFromProductUrl(product.url);

    if (!slug) {
      return null;
    }

    return {
      slug,
      path: getPath(product.url) || null,
      variantSku: (product.variantId || '').replace(product.id ?? '', ''),
    };
  } catch {
    return null;
  }
};

export default getQuickViewStateFromProduct;
